import { Button, IconTrash16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './RemoveFavorite.css';
import { IRemoveFavoriteParameters } from '../../actions/favoriteEntities';
import { EEntityType, EDealType } from '../../types/filters';
import { IRemoveFavorite } from '../../types/results';

export interface IRemoveFavoriteStoreProps {
  removeFavoriteState: IRemoveFavorite;
}

export interface IRemoveFavoriteDispatchProps {
  onClick(parameters: IRemoveFavoriteParameters): void;
}

export interface IRemoveFavoriteOwnProps {
  dealType: EDealType;
  entityId: number;
  favoriteEntityType: EEntityType;
}

export type TRemoveFavoriteProps = IRemoveFavoriteStoreProps & IRemoveFavoriteDispatchProps & IRemoveFavoriteOwnProps;

export function RemoveFavorite({
  removeFavoriteState: { entityIds },
  onClick,
  entityId,
  favoriteEntityType,
  dealType,
}: TRemoveFavoriteProps) {
  return (
    <div className={styles['container']}>
      <Button
        size="XS"
        theme="fill_secondary"
        beforeIcon={<IconTrash16 color="primary_100" />}
        loading={Boolean(entityIds && entityIds.includes(entityId))}
        onClick={() => onClick({ dealType, entityId, favoriteEntityType })}
        title="Удалить из избранного"
      />
    </div>
  );
}
